import AnnaStory from './annaStory/mainStory.js';
import CoffeeBreak from './annaStory/coffeeBreak.js';
import NoCoffee from './annaStory/noCoffee.js';

export default [
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerTxt: `[Some night, 2:15 am ...]`,
        speakerTxtRS: `[Jedne noći, 2:15 ...]`
    },
    {
        backgroundImg: `assets/bgImgs/diary.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `There are no labels for love. It has no set of rules to follow. It knocks on doors when it is least expected and vanishes when it is most desired.`,
        speakerTxtRS: `Za ljubav ne postoje etikete. Nema skup pravila koje treba poštovati. Kuca na vrata kada se najmanje očekuje i nestaje kada se to najviše želi.`,
        dialogFx: `assets/dialog/joseph/joseph0001.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        speakerTxt: `Some say it's just chemical and hormonal, while others believe it's a divine gift. How am I supposed to know what it is? Perhaps I am cursed. People think I enjoy being alone, but this is not the case. I want to fall in love, I am capable of falling in love, but I cannot find a subject to love and adore.`,
        speakerTxtRS: `Neki kažu da su to samo hemikalije i hormoni, dok drugi veruju da je božanski dar. Kako da znam šta je to? Možda sam uklet. Ljudi misle da uživam u tome da sam sam, ali to nije slučaj. Želim da se zaljubim, sposoban sam da se zaljubim, ali ne mogu da nađem subjekat kojeg ću voleti i obožavati.`,
        dialogFx: `assets/dialog/joseph/joseph0002.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        speakerTxt: `Sometimes, I wonder, will I die alone, amongst the books I collected? Who will grieve over my death? Who will achingly miss me? Who will crave my existence? \n Must be a side effect of mystical tales I read. I better go to sleep now.`,
        speakerTxtRS: `Ponekad se pitam, da li ću umreti sam, među knjigama koje sam sakupio? Ko će žaliti zbog moje smrti? Kome ću bolno nedostajati? Ko će žudeti za mojim postojanjem? \n Mora biti ne željeni efekat mističnih priča koje čitam. Bolje da idem da spavam.`,
        dialogFx: `assets/dialog/joseph/joseph0003.mp3`,
        soundFx: `assets/sounds/writing.mp3`,
        soundLoop: true,
    },
    {
        backgroundImg: `assets/bgImgs/black.webp`,
        speakerName: `unset`,
        speakerTxt: `[That morning, 8:00 am ...]`,
        speakerTxtRS: `[Tog jutra, 8:00 ...]`
    },
    {
        backgroundImg: `assets/bgImgs/bedroom.webp`,
        speakerTxt: `[beep, beep, beep ...]`,
        soundFx: `assets/sounds/clock.mp3`,
        soundLoop: true,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `How in the world did morning get so early? I mean, I just went to bed. I detest getting out of bed.`,
        speakerTxtRS: `Kako je uopšte tako brzo došlo jutro? Znači, malo pre sam legao. Ne volim da ustajem iz kreveta.`,
        dialogFx: `assets/dialog/joseph/joseph0004.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/bedroom.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `I want the day to begin at 2:00 pm. Anyway, Benjamin wants me to arrive early today to work. I must be receiving some bad news.`,
        speakerTxtRS: `Želim da dan počne u 14:00. U svakom slučaju, Bojan želi da dođem ranije danas na posao. Mora da dobijam neke loše vesti.`,
        dialogFx: `assets/dialog/joseph/joseph0005.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/morning.webp`,
        speakerTxt: `"Hm! What happened to the fuel? I filled the tank the day before yesterday."`,
        speakerTxtRS: `"Hm! Šta se desilo sa gorivom? Napunio sam rezervoar prekjuče."`,
        dialogFx: `assets/dialog/joseph/joseph0006.mp3`,
    },
    {
        speakerTxt: `I can't remember if it was day before yesterday or last week. Recently, days have blended together for me. The universe is irrational. With each book I read, my personalities shifted. This week, I'll be a mystic who doesn't care about the rest of the world.`,
        speakerTxtRS: `Ne mogu se setiti da li je bilo prekjuče ili pre nedelju dana. Odnedavno, svi dani su mi se smuljali zajedno. Univerzum je iracionalan. Sa svakom knjigom koju pročitam, moje ličnosti se menjaju. Ove nedelje, biću mistik koji ne brine o ostatku sveta.`,
        dialogFx: `assets/dialog/joseph/joseph0007.mp3`,
    },
    {
        backgroundImg: `assets/bgImgs/gasStation.webp`,
        speakerName: `unset`,
        speakerTxt: `[Ring, Ring, Ring ...]`,
        soundFx: `assets/sounds/iphone-vibrate.mp3`,
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"On way, Millie."`,
        speakerTxtRS: `"Na putu sam, Milice."`,
        dialogFx: `assets/dialog/joseph/joseph0008.mp3`,
    },
    {
        speakerTxt: `I told Millie I was coming. Why are people rushing through life? Of course, traveling takes time. My vehicle is only on wheels.`,
        speakerTxtRS: `Rekao sam Milici da dolazim. Zašto ljudi žure kroz život? Naravno, putovanje traje vreme. Moje vozilo je samo na točkovima.`,
        dialogFx: `assets/dialog/joseph/joseph0009.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/office.webp`,
        speakerName: `unset`,
        speakerTxt: `[White Matter's office ...]`,
        speakerTxtRS: `[White Matter kancelarija ...]`
    },
    {
        backgroundImg: `assets/bgImgs/office.webp`,
        characterImg: `assets/chars/millie/teethSmile.webp`,
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"Good morning, handsome."`,
        speakerTxtRS: `"Dobro jutro, lepi."`,
        dialogFx: `assets/dialog/millie/millie0001.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Why doesn't Benjamin hire a male HR for the company? That is what I dislike about women. That's why I couldn't develop feelings for women. The glitters of the world inspire them. They are aware, but they are unable to accept the reality that all that glitters is not gold.`,
        speakerTxtRS: `Zašto Bojan ne zaposli muškog HR-a za kompaniju? To je ono što ne volim kod žena. Zato nisam mogao da razvijem osećanja prema ženama. Sijalice sveta ih inspirišu. One su svesne, ali ne mogu da prihvate realnost da sve što sija nije zlato.`,
        dialogFx: `assets/dialog/joseph/joseph0010.mp3`
    },
    {
        speakerTxt: `I want someone who sees beyond the glitz and glam, who values intelligence over wealth. I'm looking for someone who can talk about the visible and invisible dimensions of the world, the cosmos, human nature, death, and everything else.`,
        speakerTxtRS: `Tražim nekoga ko vidi iza sjaja i glamura, ko vrednuje inteligenciju preko bogatstva. Tražim nekoga ko može da priča o vidljivim i nevidljivim dimenzijama sveta, kosmosa, prirodi ljudi, smrti i svemu ostalom.`,
        dialogFx: `assets/dialog/joseph/joseph0011.mp3`

    },
    {
        speakerTxt: `"Millie, who's that woman at my desk?"`,
        speakerTxtRS: `"Milice, ko je ta devojka kod mog stola?"`,
        dialogFx: `assets/dialog/joseph/joseph0012.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"A special present for you."`,
        speakerTxtRS: `"Poseban poklon za tebe."`,
        dialogFx: `assets/dialog/millie/millie0002.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"What? I don't like presents. Also, she looks new."`,
        speakerTxtRS: `"Šta? Ne volim poklone. Takođe, ona izgleda nova."`,
        dialogFx: `assets/dialog/joseph/joseph0013.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"She sure is new."`,
        speakerTxtRS: `"Ona je sigurno nova."`,
        dialogFx: `assets/dialog/millie/millie0003.mp3`
    },
    {
        speakerTxt: `"Assemble everyone! I'd like to introduce Anna to you. My friend Anna joined White Matter to help us with our writing. We were unable to find a more suitable candidate than Anna because we needed someone intelligent to keep Joseph company."`,
        speakerTxtRS: `"Pažnja svi! Želim da vam predstavim Anu. Moja prijateljica Ana se pridružila White Matter-u da nam pomogne sa našim pisanjem. Nismo mogli da nađemo boljeg kandidata od Ane, jer nam je trebao neko inteligentan ko će da parira Jožefu."`,
        dialogFx: `assets/dialog/millie/millie0004.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `I didn't ask for a company, especially a girl. I could write content myself. Or I could hire someone online. Is Benjamin taking decisions alone?`,
        speakerTxtRS: `Nisam tražio društvo, posebno devojku. Mogao sam sam da pišem sadržaj. Ili sam mogao da zaposlim nekoga online. Da li Bojan donosi odluke sam?`,
        dialogFx: `assets/dialog/joseph/joseph0014.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"Guess what's special about Anna guys. Anna is a doctor by profession yet she has passion for writing. She writes real cool stuff."`,
        speakerTxtRS: `"Pogodite šta je posebno kod Ane. Ana je lekar po profesiji, ali ima strast za pisanjem. Ona piše stvarno cool stvari."`,
        dialogFx: `assets/dialog/millie/millie0005.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `That's clearly not special. This is obviously not special. It's nothing special to betray the profession you spent time and money on. This is not a cause for celebration.`,
        speakerTxtRS: `To je ništa posebno. To nije ništa posebno da zanemariš profesiju koju si proveo vreme i novac. Ovo nije razlog za slavlje.`,
        dialogFx: `assets/dialog/joseph/joseph0015.mp3`
    },
    {
        speakerTxt: `"Make way, people. Need to see boss."`,
        speakerTxtRS: `"Ljudi, Napravite put. Treba da vidim šefa."`,
        characterImg: `unset`,
        dialogFx: `assets/dialog/joseph/joseph0016.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/benjaminOffice.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/benjamin/closedSmile.webp`,
        speakerTxt: `"What is this all about Benjamin?"`,
        speakerTxtRS: `"Šta je ovo sve Bojane?"`,
        dialogFx: `assets/dialog/joseph/joseph0017.mp3`
    },
    {
        speakerTxt: `I am angry with my business partner, who took care of me like a big brother ever since my mother left me.`,
        speakerTxtRS: `Besan sam na svog poslovnog partner, koji je brinuo o meni kao veliki brat od kada me je mama ostavila.`,
        dialogFx: `assets/dialog/joseph/joseph0018.mp3`
    },
    {
        speakerTxt: `"I told you, I don't need anyone around, at least not now. I can manage things on my own."`,
        speakerTxtRS: `"Rekao sam ti, ne trebam nikoga oko sebe, bar ne za sada. Mogu da se snalazim sam."`,
        dialogFx: `assets/dialog/joseph/joseph0019.mp3`
    },
    {
        speakerName: `Benjamin Young`,
        speakerNameRS: `Bojan Mladenović`,
        speakerTxt: `"Joseph, how long are you planning to work alone, live alone and cry alone?"`,
        speakerTxtRS: `"Jožef, koliko dugo planiraš da radiš sam, živiš sam i plačeš sam?"`,
        dialogFx: `assets/dialog/benjamin/benjamin0001.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `What is Benjamin talking about? I don't cry.`,
        speakerTxtRS: `Šta Bojan priča? Ja ne plačem.`,
        dialogFx: `assets/dialog/joseph/joseph0020.mp3`
    },
    {
        speakerTxt: `"What? I don't cry!"`,
        speakerTxtRS: `"Šta? Ja ne plačem!"`,
        dialogFx: `assets/dialog/joseph/joseph0021.mp3`
    },
    {
        speakerTxt: `I snapped back. Benjamin has an old habit of moving away from the topic.`,
        speakerTxtRS: `Odbrusio sam nazad. Bojan ima staru naviku da zaobilazi temu.`,
        dialogFx: `assets/dialog/joseph/joseph0022.mp3`
    },
    {
        speakerTxt: `"Aren't we talking about the new girl Benjamin?"`,
        speakerTxtRS: `"Nismo li mi pričali o novoj devojci Bojane?"`,
        dialogFx: `assets/dialog/joseph/joseph0023.mp3`
    },
    {
        speakerTxt: `I need to get him back to real trouble than my crying alone. And what's wrong with crying alone? Everyone cries alone. Crying in front of people is more embarrassing than painful. Shedding tears is healthy for soul.`,
        speakerTxtRS: `Moram da ga vratim na pravi problem nego na moje plakanje sam. I šta ako plačem sam? Svi plaču sami. Plakanje pred ljudima je više sramno nego bolno. Suze su zdrave za dušu.`,
        dialogFx: `assets/dialog/joseph/joseph0024.mp3`
    },
    {
        speakerName: `Benjamin Young`,
        speakerNameRS: `Bojan Mladenović`,
        speakerTxt: `"Her name's Anna. And she's a good one. Worth your company. You'll enjoy working with her. And always remember to be nice to her!"`,
        speakerTxtRS: `"Njen ime je Ana. I ona je dobra. Vredi tvog društva. Uživaćeš raditi sa njom. I uvek se seti da budeš ljubazan prema njoj!"`,
        dialogFx: `assets/dialog/benjamin/benjamin0002.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `That is probably the last thing I can be.`,
        speakerTxtRS: `To je verovatno poslednja stvar koja mogu da budem.`,
        dialogFx: `assets/dialog/joseph/joseph0025.mp3`
    },
    {
        backgroundImg: `assets/bgImgs/JosephOffice.webp`,
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedSmile.webp`,
        speakerTxt: `...`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Here you are! I have just come to brief Anna about office, staff and the work we do."`,
        speakerTxtRS: `"Tu si! Pokazujem Ani kancelariju, zaposlene i posao kojim se bavimo."`,
        dialogFx: `assets/dialog/millie/millie0006.mp3`
    },
    {
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Anna, don't you think he is the hottest guy in the entire world, flaming fire with eyes?"`,
        speakerTxtRS: `"Ana, ne misliš li da je on najlepši momak na svetu, sa plamenom u očima?"`,
        dialogFx: `assets/dialog/millie/millie0007.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Millie is again flattering me to the point of madness.`,
        speakerTxtRS: `Milica mi opet laska do ludila.`,
        dialogFx: `assets/dialog/joseph/joseph0026.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"Sure."`,
        speakerTxtRS: `"Da."`,
        dialogFx: `assets/dialog/anna/anna0001.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"Anyway, Anna, Joseph is the cofounder of White Matter. He suggested the name for the company. He extracted this name from biology class. Joseph is very interested in brain studies. If he weren't a programmer, he would have been a brain surgeon."`,
        speakerTxtRS: `"U svakom slučaju, Ana, Jožef je koosnivač White Matter-a. On je predložio ime kompanije. Izvadio je ime iz biologije. Jožef je jako zainteresovan za neurohirurgiju. Da nije bio programer, bio bi neurohirurg."`,
        dialogFx: `assets/dialog/millie/millie0008.mp3`
    },
    {
        speakerTxt: `"Joseph doesn't boss around, that's because he has to deal with people which he least likes. So he chose this room to work. Technically, he is a freelancer. He writes codes for multinational companies around the globe."`,
        speakerTxtRS: `"Jožef ne upravlja, to je zato što mora da se bavi ljudima što najmanje voli. Zato je izabrao ovu sobu za rad. Tehnički, on je freelancer. Piše kodove za multinacionalne kompanije širom sveta."`,
        dialogFx: `assets/dialog/millie/millie0009.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Millie appreciates what I do, even if she is further from the idea what coding is.`,
        speakerTxtRS: `Milica ceni šta radim, čak i ako je daleko od ideje šta je programiranje.`,
        dialogFx: `assets/dialog/joseph/joseph0027.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Impressive."`,
        speakerTxtRS: `"Impresivno."`,
        dialogFx: `assets/dialog/anna/anna0002.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `That's all? I am more than impressive. Though I don't like Millie around but I want to talk more about what I do.`,
        speakerTxtRS: `To je sve? Ja sam impresivniji. Iako ne volim Milicu oko sebe, želim da priča više o tome šta radim.`,
        dialogFx: `assets/dialog/joseph/joseph0028.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"More over, Joseph recently made an app for the company. It's about finding the best suitable doctors around. One click and you get the appointment."`,
        speakerTxtRS: `"Šta više, Jožef je nedavno napravio aplikaciju za kompaniju. Radi se o pronalaženju najboljih doktora u okolini. Jedan klik i imate termin."`,
        dialogFx: `assets/dialog/millie/millie0010.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `Millie didn't fail me today.`,
        speakerTxtRS: `Milica me nije razočarala danas.`,
        dialogFx: `assets/dialog/joseph/joseph0029.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanović`,
        speakerTxt: `"Our company has the website with crazy traffic. Joseph has a blog too. Now, dear Anna, you are writing for the company and Mr. Perfection. You job is harder than writing codes."`,
        speakerTxtRS: `"Naša kompanija ima sajt sa velikim saobraćajem. Jožef ima i blog. Sad, draga Ana, ti pišeš za kompaniju i gospodina Perfekcionistu. Tvoj posao je teži od pisanja koda."`,
        dialogFx: `assets/dialog/millie/millie0011.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedEyesSmile.webp`,
        speakerTxt: `"I can do that."`,
        speakerTxtRS: `"To mogu da uradim."`,
        dialogFx: `assets/dialog/anna/anna0003.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        characterImg: `assets/chars/millie/closedSmile.webp && assets/chars/anna/closedSmile.webp`,
        speakerTxt: `I like women with strong will. So far I have no problem with the newbie.`,
        speakerTxtRS: `Volim žene sa jakim karakterom. Za sada nemam problema sa novajlijom.`,
        dialogFx: `assets/dialog/joseph/joseph0030.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"You don't have to worry about me Joseph. I am not taking your room. Millie assigned me a desk right there."`,
        speakerTxtRS: `"Ne moraš da brineš za mene Jožefe. Ne uzimam tvoju kancelariju. Milica mi je dodelila sto tamo."`,
        dialogFx: `assets/dialog/anna/anna0004.mp3`
    },
    {
        speakerName: `Joseph Smith`,
        speakerNameRS: `Jožef Kovač`,
        speakerTxt: `"Good."`,
        speakerTxtRS: `"Dobro."`,
        dialogFx: `assets/dialog/joseph/joseph0031.mp3`
    },
    {
        speakerTxt: `That was all I could say. I wanted to say good for you, grateful, thank you very much but I struggled with words. This girl with brown eyes has shaken my confidence a little bit.`,
        speakerTxtRS: `To je bilo sve što sam uspeo da kažem. Hteo sam da kažem dobro za vas, zahvalan, hvala vam puno, ali sam se mučio sa rečima. Ova devojka smeđih očiju je malo poljuljala moje samopouzdanje.`,
        dialogFx: `assets/dialog/joseph/joseph0032.mp3`
    },
    {
        speakerName: `Millie Johnson`,
        speakerNameRS: `Milica Jovanić`,
        speakerTxt: `"I'm sure you'll fit right into the team. If you have any questions, please don't hesitate to ask. Welcome aboard!"`,
        speakerTxtRS: `"Sigurna sam da ćeš se uklopiti u tim. Ako i maš bilo kakvih pitanja, ne ustručavaj se da ih postaviš. Dobrodošla!"`,
        dialogFx: `assets/dialog/millie/millie0012.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        speakerTxt: `"Thank you."`,
        speakerTxtRS: `"Hvala ti."`,
        dialogFx: `assets/dialog/anna/anna0005.mp3`
    },
    {
        speakerName: `Anna Adams`,
        speakerNameRS: `Ana Adamović`,
        characterImg: `assets/chars/anna/closedSmile.webp`,
        speakerTxt: `"I am going to get coffee. Do you want some?"`,
        speakerTxtRS: `"Idem da uzmem kafu, da donesem i tebi?"`,
        dialogFx: `assets/dialog/anna/anna0006.mp3`
    },
    {
        speakerName: `unset`,
        choicesBtns: [
            `Decline coffee`,
            `Yes, sure`,
        ],
        choicesBtnsRS: [
            `Odbij kafu`,
            `Da, može`,
        ],
        appendNextStoryParts: [
            [NoCoffee, AnnaStory],
            [CoffeeBreak, AnnaStory]
        ]
    }
];